import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { ModalController } from "ionic-angular";
import { BaseComponent } from "../../../core/components/base.component";
import { JobStatusTransitionService } from "../../services/work-flow/job-status-transition.service";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { JobStatus } from "../../business-objects/job-status/job-status.model";
import { Subject } from 'rxjs';

@Component({
    selector: "job-status-item",
    templateUrl: "job-status-item.component.html",
    viewProviders: [
        {
            provide: JobStatusTransitionService,
            useClass: JobStatusTransitionService,
            deps: [
                VasAppFacade
            ]
        }
    ]
})
export class JobStatusItemComponent extends BaseComponent implements OnInit, OnChanges {
    @Input() jobStatus: string;
    @Input() locked: boolean = false;
    @Output() changed: EventEmitter<string> = new EventEmitter<string>();

    protected jobStatuses: Array<JobStatus> = [];
    protected nextJobStatuses: Array<JobStatus> = [];
    protected jobStatus$ = new Subject<string>();

    constructor(
        protected modalController: ModalController,
        protected appFacade: VasAppFacade,
        protected jobStatusTransitionService: JobStatusTransitionService
    ) {
        super();
    }

    ngOnInit(): void {

        this.appFacade.objects.jobStatus.store
            .getAll()
            .takeUntil(this.ngUnsubscribe)
            .subscribe(list => this.jobStatuses = list);

        this.jobStatus$
            .concatMap(id => this.jobStatusTransitionService.getJobStatuses(id).take(1))
            .takeUntil(this.ngUnsubscribe)
            .subscribe(jobStatuses => this.nextJobStatuses = jobStatuses);

        this.jobStatus$.next(this.jobStatus);
    }

    ngOnChanges(): void {
        this.jobStatus$.next(this.jobStatus);
    }

    get title(): string {
        const jobStatus: JobStatus = this.jobStatuses && this.jobStatuses.find(_jobStatus => _jobStatus.id === this.jobStatus);

        if (!jobStatus) {
            return "";
        }

        return jobStatus.title;
    }

    get showJobStatusPicker(): boolean {
        return this.nextJobStatuses.length > 1 && !this.locked;
    }

    get showJobStatusNextButton(): boolean {
        return this.nextJobStatuses.length === 1 && !this.locked;
    }

    get showLastStatusIcon(): boolean {
        return this.nextJobStatuses.length === 0;
    }

    get nextJobStatusId(): string {
        return this.nextJobStatuses.length === 1 ? this.nextJobStatuses[0].id as string : "";
    }

    onClickLabel(): void {
        if (this.showJobStatusPicker) {
            this.onPickStatus();
        } else {
            this.onNextStatus();
        }
    }

    onPickStatus(): void {
        const modal = this.modalController.create("JobJobStatusFormComponent", {
            jobStatus: this.jobStatus
        });

        modal.onDidDismiss(jobStatusId => {
            this.updateJobStatus(jobStatusId);
        });

        modal.present();
    }

    onNextStatus(): void {
        this.updateJobStatus(this.nextJobStatusId);
    }

    protected updateJobStatus(jobStatus: string): void {

        if (!jobStatus) {
            return;
        }

        this.jobStatus = jobStatus;
        this.changed.next(jobStatus);
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/job-status-item/job-status-item.component.ts